<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.TRIAGEM">
            <rkm-layout-body title="Acolhimento">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.printCarteiraVacinacao()"
                        color="info"
                    >
                        Imprimir carteirinha de vacinação
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <Form
                        :fila-id="filaId"
                        @redirect="redirectToList"
                        @saved="saved"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Acolhimento">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>TRIAGEM</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/pre-atendimento/Form'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {Form},
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        enums: {setorTipo},
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        redirectToList() {
            this.unsetShowExitFormConfirmation()
            this.$router.push('/ambulatorio/pre-atendimento/index')
        },
        saved() {
            this.redirectToList()
        },
        exit() {
            this.showExitConfirmation(async () => {
                this.setLoading()

                return this.repositories.fila.sendBack(this.filaId)
                    .then(() => this.redirectToList())
                    .finally(() => this.unsetLoading())
            }, this.handleError)
        },
    },
    mixins: [error, repository],
    props: {
        filaId: {type: Number, required: true},
    },
}
</script>